import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";

const HelmetMeta = ( { page }) => {

    const [ t ] = useTranslation("global")

    return (
        <Helmet>
            <title>{t(`meta.${page}.title`)}</title>
            <meta name="description" content={t(`meta.${page}.description`)} />
            <meta name="keywords" content={t(`meta.${page}.keywords`)} />
            <meta property="og:title" content={t(`meta.${page}.title`)} />
            <meta property="og:description" content={t(`meta.${page}.description`)} />
            <meta property="og:image" content="https://www.bemyguest.ch/img/logo_bmg_big.png"/>
            <meta property="og:url" content={`https://www.bemyguest.ch/${page}`} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={t("meta.home.title")} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={t(`meta.${page}.title`)} />
            <meta name="twitter:description" content={t(`meta.${page}.description`)} />
            <meta name="twitter:image" content="https://www.bemyguest.ch/img/logo_bmg_big.png"/>
        </Helmet>      
    );

};

export default HelmetMeta;